import { moveAndCollide } from '../../engine/Physics';
import { Bullet } from '../Bullet';
import { Enemy, type EnemyContext } from './Enemy';
import type { EnemyDef } from '../../types';

const TERMINAL_VY = 18;

export class Pepper extends Enemy {
  override width = 28;
  override height = 40;
  vy = 0;
  private cooldownMs: number;
  private shootInterval: number;
  private bulletSpeed: number;

  constructor(def: EnemyDef) {
    super(def);
    this.shootInterval = def.shootInterval ?? 1500;
    this.bulletSpeed = def.bulletSpeed ?? 4;
    this.cooldownMs = this.shootInterval;
    this.draw();
  }

  private draw(): void {
    const g = this.gfx;
    g.clear();
    g.poly([-14, 18, 14, 18, 0, -16])
      .fill({ color: 0xe53935 })
      .stroke({ color: 0x000000, width: 2 });
    g.rect(-2, -22, 4, 8)
      .fill({ color: 0x6abf6a })
      .stroke({ color: 0x000000, width: 1 });
    g.circle(0, -23, 3).fill({ color: 0xffa000 });
    g.circle(-1, -25, 1.6).fill({ color: 0xffe082 });
    g.circle(-4, 4, 2).fill({ color: 0xffffff });
    g.circle(4, 4, 2).fill({ color: 0xffffff });
    g.circle(-4, 4, 1).fill({ color: 0x000000 });
    g.circle(4, 4, 1).fill({ color: 0x000000 });
  }

  override step(ctx: EnemyContext): void {
    if (!this.alive) return;

    this.vy += ctx.cfg.gravity;
    if (this.vy > TERMINAL_VY) this.vy = TERMINAL_VY;
    const box = this.bounds();
    const res = moveAndCollide(box, 0, this.vy, ctx.solids);
    this.x = box.x;
    this.y = box.y;
    if (res.hitY) this.vy = 0;

    this.cooldownMs -= ctx.stepDt * 1000;
    if (this.cooldownMs <= 0) {
      this.shoot(ctx);
      this.cooldownMs = this.shootInterval;
    }
  }

  private shoot(ctx: EnemyContext): void {
    const cx = this.x + this.width / 2;
    const cy = this.y + this.height / 2;
    const px = ctx.player.pos.x + ctx.player.width / 2;
    const py = ctx.player.pos.y + ctx.player.height / 2;
    const dx = px - cx;
    const dy = py - cy;
    const len = Math.hypot(dx, dy) || 1;
    const vx = (dx / len) * this.bulletSpeed;
    const vy = (dy / len) * this.bulletSpeed;
    const muzzle = 18;
    const bullet = new Bullet(cx + (dx / len) * muzzle, cy + (dy / len) * muzzle, vx, vy, 'enemy');
    ctx.spawnBullet(bullet);
  }
}
